"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const toolkit_1 = require("@reduxjs/toolkit");
const personalContactsSlice_1 = require("./personalContactsSlice");
const screenConstants_1 = require("../../../constants/screenConstants");
const useAppNavigation_1 = __importDefault(require("../../../hooks/useAppNavigation"));
const navContainer_1 = __importDefault(require("../../../components/navContainer/navContainer"));
const store_1 = require("../../../store");
const input_1 = __importStar(require("../../../components/input/input"));
const utils_1 = require("../../../utils/utils");
const primaryButton_1 = __importDefault(require("../../../components/primaryButton/primaryButton"));
const analytics_1 = require("../../../utils/analytics/analytics");
const PersonalContacts = () => {
    const dispatch = (0, store_1.useAppDispatch)();
    const navigation = (0, useAppNavigation_1.default)();
    const { logEventWithExtraProperties } = (0, analytics_1.useAnalytics)();
    const { emailAuth, phoneNumberAuth, userData } = (0, store_1.useAppSelector)((state) => ({
        emailAuth: state.auth.email ? state.auth.email : '',
        phoneNumberAuth: state.home.user_data ? state.home.user_data.personal_contacts.phone_number : '',
        userData: state.home.user_data,
    }));
    const [errors, setErrors] = (0, react_1.useState)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [emailState, setEmail] = (0, react_1.useState)(emailAuth);
    const [phoneNumber, setPhoneNumber] = (0, react_1.useState)(phoneNumberAuth);
    (0, react_1.useEffect)(() => {
        setEmail(emailAuth);
        setPhoneNumber(phoneNumberAuth);
    }, [userData]);
    // SUBMIT FORM DATA
    const submitForm = async () => {
        setIsLoading(true);
        const payload = {
            email: emailState.toString(),
            phone_number: phoneNumber.toString(),
        };
        const result = await dispatch((0, personalContactsSlice_1.submitPersonalContacts)(payload));
        logEventWithExtraProperties('api_call', {
            name: 'submit_personal_contacts',
            status: 'submitted',
            location: 'screen_PersonalContacts',
        });
        if ((0, toolkit_1.isFulfilled)(result)) {
            logEventWithExtraProperties('api_call', {
                name: 'submit_personal_contacts',
                status: 'success',
                location: 'screen_PersonalContacts',
            });
            setErrors(undefined);
            setIsLoading(false);
            navigation.navigate(screenConstants_1.PROFILE_SCREEN);
        }
        else {
            logEventWithExtraProperties('api_call', {
                name: 'submit_personal_contacts',
                status: 'fail',
                location: 'screen_PersonalContacts',
            });
            setErrors(result.payload);
            setIsLoading(false);
        }
    };
    return (react_1.default.createElement(navContainer_1.default, { errors: errors, isLoading: isLoading, footer: react_1.default.createElement(primaryButton_1.default, { title: "Save", onPress: submitForm, disabled: false, eventName: "personalContacts_save" }), childrenTitle: "Contacts" },
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_EMAIL, label: "Your email", placeholder: "Your email", setValue: setEmail, error: (0, utils_1.getError)('email', errors), value: emailState }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PHONE, label: "Your phone number", setValue: setPhoneNumber, error: (0, utils_1.getError)('phone_number', errors), value: phoneNumber })));
};
exports.default = PersonalContacts;
